
import CheckSVG from "../../svg/checkSVG"

import styles from "./Checkbox.module.scss"

function Checkbox({ uniqueId,checked,onChange,label }) {
  return (
    <fieldset className={`${styles.checkbox} ${checked ? styles.checkboxChecked : ""}`}>
      <input id={uniqueId} type="checkbox" checked={checked} onChange={onChange} />
      <button onClick={onChange}>
        <span className={styles.checkboxBtn} onClick={onChange}>
          {checked ? (
            <CheckSVG />
          ) : (
            <div className={styles.emptyCheckbox} />
          )}
        </span>
        <label htmlFor={uniqueId}>
          {label}
        </label>
      </button>
    </fieldset>
  )
}

export default Checkbox